import "./ProductCard.css";

function ProductCard({ product, onAddToCart }) {
  const onSale = product.compareAtPrice && product.compareAtPrice > product.price;

  // Pick a class based on product name
  const getThemeKey = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("hibiskus")) return "hibiskus";
  if (n.includes("mente")) return "mente";
  if (n.includes("spirulina")) return "spirulina";
  if (n.includes("klorofil")) return "klorofil";
  if (n.includes("beer")) return "gingerbeer";
  if (n.includes("xhinxher") || n.includes("karafil")) return "xhinxher";
  if (n.includes("origjinale")) return "originale";
  return "";
};

const themeClass = getThemeKey(product.name);
  return (
    <div className={`product-card ${themeClass}`}>
      <img 
        src={product.image} 
        alt={product.name} 
        className="product-image mb-3"
      />
      <h5>{product.name}</h5>
      <p>{product.description}</p>
      <div className="mb-3">
        {onSale && <span className="old-price me-2">L {product.compareAtPrice}</span>}
        <span className="price">L {product.price}</span>
      </div>

      <div className="d-flex gap-2">
        <button 
          className="btn btn-outline-success flex-fill"
          onClick={() => onAddToCart(product)}
        >
          Add to Cart
        </button>
        <a href={product.checkoutUrl} className="btn btn-success flex-fill">
          Buy Now
        </a>
      </div>
    </div>
  );
}

export default ProductCard;
